import React, { ReactNode, createContext, useContext } from 'react';

export interface SupportContextProps {
  phoneNumber: string;
  isInstallationOffer?: boolean;
  onChatClick: () => void;
  onCallClick: () => void;
}

const SupportContext = createContext<SupportContextProps | undefined>(undefined);

export const SupportProvider = ({
  phoneNumber,
  onChatClick,
  onCallClick,
  children,
}: SupportContextProps & {
  children: ReactNode;
}) => <SupportContext.Provider value={{ phoneNumber, onChatClick, onCallClick }}>{children}</SupportContext.Provider>;

export const useSupport = () => {
  const context = useContext(SupportContext);
  if (context === undefined) {
    throw new Error('useSupport must be used within a SupportProvider');
  }
  return context;
};
